export default class AccessibilityManager { // Add export default
  constructor() {
    this.isHighContrastMode = false;
    this.isLargerTextMode = false;
    this.isScreenReaderMode = false;
    this.isReducedMotionMode = false;
    
    this.loadSettings();
  }

  loadSettings() {
    const saved = localStorage.getItem('squdle-accessibility');
    if (saved) {
      const settings = JSON.parse(saved);
      this.isHighContrastMode = settings.highContrast;
      this.isLargerTextMode = settings.largerText;
      this.isScreenReaderMode = settings.screenReader;
      this.isReducedMotionMode = settings.reducedMotion;
    }
  }

  applySettings() {
    document.body.classList.toggle('high-contrast-mode', this.isHighContrastMode);
    document.body.classList.toggle('larger-text', this.isLargerTextMode);
    document.body.classList.toggle('reduce-motion', this.isReducedMotionMode);
    localStorage.setItem('squdle-accessibility', JSON.stringify({
      highContrast: this.isHighContrastMode,
      largerText: this.isLargerTextMode,
      screenReader: this.isScreenReaderMode,
      reducedMotion: this.isReducedMotionMode
    }));
  }

  announce(message, isAlert = false) {
    const target = document.getElementById(isAlert ? 'sr-announcer' : 'sr-status');
    if (target) {
      target.textContent = message;
      setTimeout(() => target.textContent = '', 5000);
    }
  }
}
// Removed window export
